import { useContext, createContext } from "react";
export const useTreeContext = () => {
    const context = useContext(TreeContext);
    if (context === undefined) {
        throw new Error("A component has been used outside of the Provider components");
    }
    return context;
};
export const TreeContext = createContext(undefined);
